import { IState } from './types';
import mutations from './mutations';

const state: IState = {
  isVideoPlayed: false
};

export default {
  namespaced: true,
  state,
  mutations
};
